import React from "react";
import Announcement from "../components/Announcement";
import Hero from "../components/hero/Hero";
import Navbar from "../components/navbar/Navbar";
import Products from "../components/product/Products";
import Footer from "../components/footer/Footer";
import Categories from "../components/categories/Categories";
const Home = () => {
  return (
    <div>
      <Announcement />
      <Navbar />
      <Hero/>
      <Categories />
      <Products/>
      <Footer/>
    </div>
  );
};

export default Home;